import NoEncryptionInterceptor from "../lib/noEncryptionInterceptor";
const url = "querymanager/insurance/auth/captcha";

// Reuses insurancex_mw's existing direct-login captcha (GET, already public
// through kawachgateway_mw - no gateway config change was needed for this).
// Returns { captchaId, imageDataUri }.
export async function getCaptcha() {
  const response = await NoEncryptionInterceptor.get(url);
  return response.data?.apiResponseData;
}
